import React, { useState } from "react";
import AddToolTip from "./../../../components/AddToolTip/AddToolTip";
import { get } from "lodash-es";
import {
  jsonToStringConverter,
  stringToFunctionConverter,
} from "../../../utils";

const PreviewSectionForConfigureOutput = ({
  values,
  showSource,
  deserializeHeaderMapJson,
}) => {
  const [show, setShow] = useState(false);

  return (
    <>
      {!show ? (
        <div
          className="d-flex align-items-baseline"
          style={{
            backgroundColor: "#f7f7f7",
            padding: "16px",
            position: "fixed",
            bottom: "0",
            width: "100%",
            marginLeft: showSource ? "307px" : "0px",
          }}
        >
          <span className={`ft-14 fw-500 mr-2`}>
            Preview<span class="active-dot">●</span>
          </span>

          <div className="d-flex preview-card-flair justify-content-between">
            <span className="d-flex ft-12" style={{ width: "95%" }}>
              <span className="grey-text mr-3">Value:</span>
              <AddToolTip
                name={stringToFunctionConverter(
                  jsonToStringConverter(values?.valueData),
                  2,
                  deserializeHeaderMapJson
                )?.toString()}
              />
            </span>
          </div>

          <span
            className={`ft-12 link-text-mapper cursor-pointer ml-2 `}
            onClick={() => setShow(!show)}
          >
            View more
          </span>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "#f7f7f7",
            padding: "16px",
            position: "fixed",
            bottom: "0",
            width: "100%",
            marginLeft: showSource ? "307px" : "0px",
          }}
        >
          <div
            className="d-flex justify-content-between mb-2"
            style={{ width: "70%" }}
          >
            <span className="ft-14 fw-500">
              Preview<span class="active-dot">●</span>
            </span>
            <span
              className="ft-12 link-text-mapper cursor-pointer"
              onClick={() => setShow(!show)}
            >
              View less
            </span>
          </div>

          <div className="d-flex preview-card " style={{ width: "70%" }}>
            <div style={{ width: "30%" }}>
              <span className="d-flex ft-10 w-80">
                <span className="grey-text mr-1 mt-1">Value:</span>
                <AddToolTip
                  className="mt-2 ml-1"
                  name={stringToFunctionConverter(
                    jsonToStringConverter(values?.valueData),
                    2,
                    deserializeHeaderMapJson
                  )}
                />
              </span>
            </div>

            <div className="w-70">
              <div>
                <div className="ft-12 fw-500">Value Expression</div>
                <span className="d-flex ft-10">
                  <span className="grey-text mr-1 w-100">
                    {" "}
                    {jsonToStringConverter(values?.valueData).slice(0, 15) ==
                    "undefined(" ? (
                      " "
                    ) : (
                      <AddToolTip
                        name={jsonToStringConverter(values?.valueData)}
                      >
                        {jsonToStringConverter(values?.valueData).length > 60
                          ? `${jsonToStringConverter(values?.valueData).slice(
                              0,
                              60
                            )}...`
                          : jsonToStringConverter(values?.valueData)}
                      </AddToolTip>
                    )}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewSectionForConfigureOutput;
